/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { Filter, Input, toInt, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { t } from 'i18next';
import { Brand } from 'models/api/brand';
import { Col, Row } from 'reactstrap';

const BrandFilter = () => {
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<Filter<Omit<Brand, 'props'>>>();
    return (
        <>
            <Row>
                <Col>
                    <Input
                        type="number"
                        id="b-filter-id"
                        value={draftFilter.id || ''}
                        onChange={(e) => {
                            setDraftFilter((prevState) => ({
                                ...prevState,
                                id: toInt(e.target.value),
                            }));
                        }}
                        label={t('BackOfficeId')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="b-filter-name"
                        value={draftFilter.name || ''}
                        onChange={(e) => {
                            setDraftFilter((prevState) => ({ ...prevState, name: e.target.value }));
                        }}
                        label={t('BackOfficeName')}
                    />
                </Col>
            </Row>
        </>
    );
};

export default BrandFilter;
